import { create } from 'zustand';
import type { PromptEntry } from '../types';

interface PromptState {
  prompts: PromptEntry[];
  skillFilter: string;
  typeFilter: string;

  addPrompt: (p: PromptEntry) => void;
  setPrompts: (p: PromptEntry[]) => void;
  setSkillFilter: (f: string) => void;
  setTypeFilter: (f: string) => void;
}

export const usePromptStore = create<PromptState>((set) => ({
  prompts: [],
  skillFilter: '',
  typeFilter: '',

  addPrompt: (p) => set((s) => ({ prompts: [...s.prompts, p] })),
  setPrompts: (prompts) => set({ prompts }),
  setSkillFilter: (skillFilter) => set({ skillFilter }),
  setTypeFilter: (typeFilter) => set({ typeFilter }),
}));
